import { render, staticRenderFns } from "./zone_criterium.vue?vue&type=template&id=310d1abf&scoped=true&"
import script from "./zone_criterium.vue?vue&type=script&lang=js&"
export * from "./zone_criterium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310d1abf",
  null
  
)

export default component.exports